import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { CustomDataGrid } from "src/Shared/Components";
import { useStore } from "src/Shared/Hooks";
import { userColumns } from "./UserManagement.column";
import { IUser, IPageRequest } from "src/Shared/Interfaces";
import { Box, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { GridPaginationModel } from "@mui/x-data-grid";
import useDebounce from "src/Shared/Hooks/UseDebounce.hook";

const UserManagement: React.FC = () => {
  const {
    rootStore: {
      settingsStore: {
        getUsers,
        userList,
        gridLoading,
        impersonateUser,
      },
    },
  } = useStore();

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [gridPagination, setGridPagination] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });

  const [request, setRequest] = useState<IPageRequest<any>>({
    pageNumber: 1,
    pageSize: 10,
    filterCollection: {
      search: "",
    },
    sortCollection: [],
  });

  const onGridPaginationChange = (data: GridPaginationModel) => {
    setGridPagination(data);
    setRequest((prev) => ({
      ...prev,
      pageNumber: data.page + 1,
      pageSize: data.pageSize,
    }));
  };

  useDebounce(
    () => {
      setRequest((prev) => ({
        ...prev,
        pageNumber: 1,
        filterCollection: {
          search: searchTerm,
        },
      }));
      setGridPagination((prev) => ({
        ...prev,
        page: 0,
      }));
    },
    500,
    [searchTerm]
  );

  useEffect(() => {
    getUsers(request);
  }, [request]);

  const handleImpersonate = (user: IUser) => {
    impersonateUser(user.userID);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <TextField
          size="small"
          placeholder="Search users..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ width: 300 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <CustomDataGrid
        loading={gridLoading}
        rows={userList?.results || []}
        columns={userColumns(handleImpersonate)}
        rowCount={userList?.totalNumberOfRecords || 0}
        getRowId={(row: IUser) => row.userID}
        style={{
          height: "calc(100vh - 220px)",
        }}
        paginationModel={gridPagination}
        onPaginationModelChange={(model, _) => onGridPaginationChange(model)}
      />
    </Box>
  );
};

export default observer(UserManagement);
